/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-indent */
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
// import moment from 'moment';
import { ModalContext } from 'App';
import Modal from 'modules/common/components/Modal';
// import ConfirmDiscount from 'modules/common/components/ConfirmDiscount';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { numberFormat } from 'helper';
import * as action from '../action';
import * as c from '../constant';

function ValidateTicketModal({
  ticket,
  approvingTicket,
  approveTicket,
  rejectTicket,
  id,
  showTransaction,
  rejecting,
}) {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');
  const ticketInfo = _.get(ticket, 'data[0].attributes');
  const includedTicketInfo = _.get(
    ticket,
    'data[0].included.apprehending_officer.attributes'
  );
  const RenderViolations = () => {
    const violations = _.get(ticket, 'data[0].included.violations') || [];
    return violations.map(data => {
      return (
        <tr key={data.attributes.violation_code}>
          <td>{data.attributes.violation_code}</td>
          <td>{data.attributes.particular}</td>
          <td>{data.attributes.reference}</td>
          <td className="text-right">
            {numberFormat(data.attributes.amount, 2)}
          </td>
        </tr>
      );
    });
  };

  const handleApproveTicket = e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to approve this OVR Application?',
      remarks => {
        // if (!discount) {
        //   discount = 0;
        // }

        approveTicket(
          id,
          {
            remarks,
          },
          () => {
            setModal({ isOpen: false });
            showTransaction(id);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true,
      true
    );
  };

  const handleReject = e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to reject this OVR Application?',
      remarks => {
        rejectTicket(
          id,
          {
            remarks,
          },
          () => {
            setModal({ isOpen: false });
            showTransaction(id);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const RenderTicket = () => (
    <>
      <table className="transaction-table table table-borderless table-sm table-striped table-hover">
        <tbody>
          <tr>
            <td className="text-dark" width="300">
              OVR Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>{(_.get(ticketInfo, 'ovr_number') || '--').toUpperCase()}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              OVR Status
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {_.get(ticketInfo, 'is_valid')
                  ? 'APPROVED'
                  : 'WAITING FOR APPROVAL'}
              </b>
            </td>
          </tr>
          {_.get(ticketInfo, 'is_valid') ? (
            <>
              <tr>
                <td className="text-dark" width="300">
                  Approved By:
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td>
                  <b>{_.get(ticketInfo, 'approved_by') || ''}</b>
                </td>
              </tr>
              <tr>
                <td className="text-dark" width="300">
                  Approved At:
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td>
                  <b>{_.get(ticketInfo, 'approved_at') || ''}</b>
                </td>
              </tr>
            </>
          ) : (
            ''
          )}
          <tr>
            <td className="text-success" colSpan={3}>
              <b>VIOLATOR&apos;S PERSONAL INFORMATION</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Last Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>{(_.get(ticketInfo, 'last_name') || '--').toUpperCase()}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Middle Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>{(_.get(ticketInfo, 'middle_name') || '--').toUpperCase()}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              First Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>{(_.get(ticketInfo, 'first_name') || '--').toUpperCase()}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Extension Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(_.get(ticketInfo, 'extension_name') || '--').toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Date of Birth
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>{_.get(ticketInfo, 'birth_date') || '--'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Mobile Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>{_.get(ticketInfo, 'mobile_number') || '--'}</b>
            </td>
          </tr>
          {/* <tr>
          <td className="text-dark" width="300">
            Place of Birth
          </td>
          <td className="text-dark" width="1">
            :
          </td>
          <td>
            <b>
              {(
                _.get(ticketInfo, 'included.region.attributes.name') ||
                '--'
              ).toUpperCase()}
              ,
              {(
                _.get(transactionInfo, 'included.province.attributes.name') ||
                '--'
              ).toUpperCase()}{' '}
              {(
                _.get(
                  transactionInfo,
                  'included.municipality.attributes.name'
                ) || '--'
              ).toUpperCase()}{' '}
              {(
                _.get(transactionInfo, 'included.barangay.attributes.name') ||
                '--'
              ).toUpperCase()}{' '}
              {(_.get(ticketInfo, 'street') || '--').toUpperCase()}
            </b>
          </td>
        </tr> */}
          <tr>
            <td className="text-success" colSpan={3}>
              <b>VIOLATOR&apos;S DRIVERS LICENSE INFORMATION</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Driver License Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(ticketInfo, 'driver_license_number') || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Valid From
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(ticketInfo, 'driver_license_validity_date_from') || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Valid To
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(ticketInfo, 'driver_license_validity_date_to') || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-success" colSpan={3}>
              <b>APPREHENSION INFORMATION</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Date of Apprehension
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(_.get(ticketInfo, 'apprehended_at') || '--').toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Vehicle Type
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>{(_.get(ticketInfo, 'vehicle_type') || '--').toUpperCase()}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Apprehending Officer
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>{(_.get(includedTicketInfo, 'name') || '--').toUpperCase()}</b>
            </td>
          </tr>
          {/* <tr>
          <td className="text-dark" width="300">
            Place of Apprehension
          </td>
          <td className="text-dark" width="1">
            :
          </td>
          <td>
            <b>
              {(
                _.get(
                  includedTicketInfo,
                  'included.apprehension_region.attributes.name'
                ) || '--'
              ).toUpperCase()}{' '}
              {(
                _.get(
                  includedTicketInfo,
                  'included.apprehension_province.attributes.name'
                ) || '--'
              ).toUpperCase()}{' '}
              {(
                _.get(
                  includedTicketInfo,
                  'included.apprehension_municipality.attributes.name'
                ) || '--'
              ).toUpperCase()}{' '}
              {(
                _.get(
                  includedTicketInfo,
                  'included.apprehension_barangay.attributes.name'
                ) || '--'
              ).toUpperCase()}{' '}
              {(_.get(ticketInfo, 'apprehension_street') || '--').toUpperCase()}{' '}
            </b>
          </td>
        </tr> */}
          <tr>
            <td className="text-dark" width="300">
              Original Total Amount
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {numberFormat(_.get(ticketInfo, 'original_total_amount'), 2)}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Discount
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>{numberFormat(_.get(ticketInfo, 'discount'), 2)}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Total Amount
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td style={{ fontSize: '15px' }}>
              <b>{numberFormat(_.get(ticketInfo, 'total_amount'), 2)}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="container">
        <div className="row">
          <p className="mr-3">List of Violations</p>
          <div className="violation-container table-responsive">
            <table className="table table-borderless table-sm table-striped table-hover">
              <thead>
                <tr>
                  <th scope="scope">Violation Code</th>
                  <th scope="scope">Particular</th>
                  <th scope="scope">Reference</th>
                  <th scope="scope" className="text-right">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <RenderViolations />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );

  if (ticket.data.length) {
    return (
      <Modal.Body>
        <div className="container">
          <div className="row">Ticket Information</div>
          <div className="row">
            <RenderTicket />
          </div>
          <div className="row">
            <div className="d-flex justify-content-center w-100">
              {_.get(ticketInfo, 'is_valid')
                ? Acl(permissions, ['OVRS APPROVE VALIDATE TICKET']) && (
                    <button
                      disabled={approvingTicket}
                      onClick={handleApproveTicket}
                      type="button"
                      className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mr-2"
                    >
                      Approve
                    </button>
                  )
                : Acl(permissions, ['OVRS APPROVE VALIDATE TICKET']) && (
                    <button
                      disabled
                      onClick={handleApproveTicket}
                      type="button"
                      className="btn btn-disabled font-weight-bold mr-2"
                    >
                      Approve
                    </button>
                  )}
              <button
                disabled={rejecting}
                onClick={handleReject}
                type="button"
                className="btn gen-btn btn-danger cms-bg-color-danger cms-outline-danger font-weight-bold"
              >
                Reject
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    );
  }
  return (
    <Modal.Body>
      <div className="container">
        <div className="d-flex align-items-center justitfy-content-center h-100 flex-column">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Ticket Information</p>
          </div>
          <button
            disabled={rejecting}
            onClick={handleReject}
            type="button"
            className="btn btn-danger mr-5"
          >
            Reject
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

ValidateTicketModal.propTypes = {
  ticket: PropTypes.instanceOf(Object).isRequired,
  approveTicket: PropTypes.instanceOf(Function).isRequired,
  rejectTicket: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  approvingTicket: PropTypes.bool.isRequired,
  rejecting: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  approvingTicket: api.loading.indexOf(c.APPROVE_TICKET) > -1,
  rejecting: api.loading.indexOf(c.REJECT_TICKET) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ValidateTicketModal);
